if (window.screen.width >= 1024) {
	const boxes = document.querySelectorAll('.perspective_card');

	boxes.forEach((box) => {
		box.addEventListener('mousemove', (e) => {
			const boxRect = box.getBoundingClientRect();
			const xPosition = (e.clientX - boxRect.left) / boxRect.width;
			const yPosition = (e.clientY - boxRect.top) / boxRect.height - 0.6;
			const xOffset = -(xPosition - 0.6);
			const dxNorm = Math.min(Math.max(xOffset, -0.6), 0.6);
			box.style.transform = `perspective(2000px)
															rotateY(${dxNorm * 10}deg)
															rotateX(${yPosition * 10}deg)`;
		});

		box.addEventListener('mouseleave', (e) => {
			box.style.transform = 'perspective(3000px) rotateY(0deg) rotateX(0deg)';
		});
	});
}
